import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";

const FaceMeshV2Page = () => <FaceMeshAsyncV2Page />;

export default FaceMeshV2Page;
